// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__weC-w","footer":"styles_footer__WhhCm","passCodeTooltip":"styles_passCodeTooltip__1PpZV"};